import { render, staticRenderFns } from "./projectReport.vue?vue&type=template&id=3b8abc2c&"
import script from "./projectReport.vue?vue&type=script&lang=js&"
export * from "./projectReport.vue?vue&type=script&lang=js&"
import style0 from "./projectReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports